export const FEMALE = '0'
export const MALE = '1'

export default [FEMALE, MALE]
